import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { loadConfig } from './http'
import { setIconBaseUrl } from './icon'

document.title = '食材订货 · 管理后台'

loadConfig().then(() => {
  fetch('/config.json').then(r => r.json()).then(c => {
    if (c.serverApiUrl) setIconBaseUrl(c.serverApiUrl)
  }).catch(() => {})
  createApp(App).use(ElementPlus, { locale: zhCn }).use(router).use(store).mount('#app')
})
